import { createSelector } from 'reselect';

export const makeSelectModalState = (modalName: string) => {
  return createSelector(
    (state: any) => {
      return state.modal;
    },
    modalState => {
      return modalState[modalName] || false;
    },
  );
};



// WEBPACK FOOTER //
// ./src/modules/modal/selectors.ts